import VoiceChatIcon from "@mui/icons-material/VoiceChat";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import {
  Accessibility as AccessibilityIcon,
  AccountBalance as AccountBalanceIcon,
  AccountCircle as AccountCircleIcon,
  AccountTree as AccountTreeIcon,
  Add as AddIcon,
  AddCircle as AddCircleIcon,
  Air as AirIcon,
  Alarm as AlarmIcon,
  AllInclusive as AllInclusiveIcon,
  AlternateEmail as AlternateEmailIcon,
  Analytics as AnalyticsIcon,
  Api as ApiIcon,
  Archive as ArchiveIcon,
  ArrowBack as ArrowBackIcon,
  ArrowBackIos as ArrowBackIosIcon,
  ArrowCircleLeft as ArrowCircleLeftIcon,
  ArrowCircleRight as ArrowCircleRightIcon,
  ArrowDropDown as ArrowDropDownIcon,
  ArrowDropDownCircle as ArrowDropDownCircleIcon,
  ArrowForward as ArrowForwardIcon,
  ArrowForwardIos as ArrowForwardIosIcon,
  ArrowLeft as ArrowLeftIcon,
  ArrowOutward as ArrowOutwardIcon,
  ArrowRight as ArrowRightIcon,
  Article as ArticleIcon,
  Assessment as AssessmentIcon,
  Assistant as AssistantIcon,
  AttachFile as AttachFileIcon,
  AutoAwesome as AutoAwesomeIcon,
  Badge as BadgeIcon,
  BarChart as BarChartIcon,
  Bolt as BoltIcon,
  Book as BookIcon,
  Bookmark as BookmarkIcon,
  Brush as BrushIcon,
  BugReport as BugReportIcon,
  Build as BuildIcon,
  Business as BusinessIcon,
  CalendarMonth as CalendarMonthIcon,
  CalendarToday as CalendarTodayIcon,
  CallMade as CallMadeIcon,
  Campaign as CampaignIcon,
  Cancel as CancelIcon,
  Category as CategoryIcon,
  Chat as ChatIcon,
  Check as CheckIcon,
  CheckCircle as CheckCircleIcon,
  Checklist as ChecklistIcon,
  Close as CloseIcon,
  Cloud as CloudIcon,
  CloudDownload as CloudDownloadIcon,
  CloudOff as CloudOffIcon,
  CloudUpload as CloudUploadIcon,
  Code as CodeIcon,
  ContactEmergency as ContactEmergencyIcon,
  ContactMail as ContactMailIcon,
  ContactPhone as ContactPhoneIcon,
  Contacts as ContactsIcon,
  CreditCard as CreditCardIcon,
  Dashboard as DashboardIcon,
  DataObject as DataObjectIcon,
  DateRange as DateRangeIcon,
  Delete as DeleteIcon,
  Description as DescriptionIcon,
  Devices as DevicesIcon,
  Domain as DomainIcon,
  Download as DownloadIcon,
  Edit as EditIcon,
  Email as EmailIcon,
  EmojiEvents as EmojiEventsIcon,
  Event as EventIcon,
  Extension as ExtensionIcon,
  Favorite as FavoriteIcon,
  FileCopy as FileCopyIcon,
  FileOpen as FileOpenIcon,
  FindInPage as FindInPageIcon,
  Flag as FlagIcon,
  Folder as FolderIcon,
  FolderZip as FolderZipIcon,
  Functions as FunctionsIcon,
  Gavel as GavelIcon,
  GridView as GridViewIcon,
  Group as GroupIcon,
  GroupAdd as GroupAddIcon,
  Help as HelpIcon,
  HexagonOutlined as HexagonOutlinedIcon,
  History as HistoryIcon,
  Home as HomeIcon,
  House as HouseIcon,
  Hub as HubIcon,
  Image as ImageIcon,
  Inbox as InboxIcon,
  Info as InfoIcon,
  InsertDriveFile as InsertDriveFileIcon,
  Insights as InsightsIcon,
  IntegrationInstructions as IntegrationInstructionsIcon,
  Inventory as InventoryIcon,
  Key as KeyIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
  Label as LabelIcon,
  Language as LanguageIcon,
  Laptop as LaptopIcon,
  Layers as LayersIcon,
  Lightbulb as LightbulbIcon,
  Link as LinkIcon,
  LinkOff as LinkOffIcon,
  List as ListIcon,
  LocalAtm as LocalAtmIcon,
  LocationOn as LocationOnIcon,
  Lock as LockIcon,
  Mail as MailIcon,
  MailOutline as MailOutlineIcon,
  Map as MapIcon,
  Memory as MemoryIcon,
  Menu as MenuIcon,
  Message as MessageIcon,
  MonetizationOn as MonetizationOnIcon,
  Monitor as MonitorIcon,
  Note as NoteIcon,
  Notifications as NotificationsIcon,
  OpenInNew as OpenInNewIcon,
  Palette as PaletteIcon,
  Pause as PauseIcon,
  Payment as PaymentIcon,
  People as PeopleIcon,
  Percent as PercentIcon,
  Person as PersonIcon,
  Phone as PhoneIcon,
  PieChart as PieChartIcon,
  PlayArrow as PlayArrowIcon,
  Psychology as PsychologyIcon,
  Public as PublicIcon,
  Receipt as ReceiptIcon,
  Refresh as RefreshIcon,
  Report as ReportIcon,
  Rectangle as RectangleIcon,
  RocketLaunch as RocketLaunchIcon,
  Route as RouteIcon,
  Rule as RuleIcon,
  Save as SaveIcon,
  Schedule as ScheduleIcon,
  Schema as SchemaIcon,
  Science as ScienceIcon,
  Search as SearchIcon,
  Security as SecurityIcon,
  Send as SendIcon,
  Settings as SettingsIcon,
  Share as ShareIcon,
  ShoppingCart as ShoppingCartIcon,
  Smartphone as SmartphoneIcon,
  SmartToy as SmartToyIcon,
  Sms as SmsIcon,
  Speed as SpeedIcon,
  Star as StarIcon,
  Start as StartIcon,
  Stop as StopIcon,
  Storage as StorageIcon,
  Summarize as SummarizeIcon,
  SupervisorAccount as SupervisorAccountIcon,
  TableChart as TableChartIcon,
  Tag as TagIcon,
  Task as TaskIcon,
  Terminal as TerminalIcon,
  ThumbUp as ThumbUpIcon,
  Timeline as TimelineIcon,
  Timer as TimerIcon,
  TimerOff as TimerOffIcon,
  TrendingUp as TrendingUpIcon,
  Tune as TuneIcon,
  Unarchive as UnarchiveIcon,
  Undo as UndoIcon,
  Upload as UploadIcon,
  UploadFile as UploadFileIcon,
  Verified as VerifiedIcon,
  VideoCall as VideoCallIcon,
  ViewList as ViewListIcon,
  Visibility as VisibilityIcon,
  Warning as WarningIcon,
  Web as WebIcon,
  Widgets as WidgetsIcon,
  Work as WorkIcon,
  X as XIcon,
} from "@mui/icons-material";
import React from "react";
import { type IconType } from "react-icons";
import { TbBrandSlack, TbBrandTeams } from "react-icons/tb";
import { isMuiPaletteColor } from "../colorUtils";

// IMPORTANT: Icon names in these maps must match those in app-portal/src/common/components/IconComponent.tsx
// to ensure consistent icon availability across both designer and runtime.

// Module-level registry of MUI icon components (avoids map recreation on every render)
const MUI_ICON_COMPONENTS: Record<string, React.ComponentType<any>> = {
  Accessibility: AccessibilityIcon,
  AccountBalance: AccountBalanceIcon,
  AccountCircle: AccountCircleIcon,
  AccountTree: AccountTreeIcon,
  Add: AddIcon,
  AddCircle: AddCircleIcon,
  Air: AirIcon,
  Alarm: AlarmIcon,
  AllInclusive: AllInclusiveIcon,
  AlternateEmail: AlternateEmailIcon,
  Analytics: AnalyticsIcon,
  Api: ApiIcon,
  Archive: ArchiveIcon,
  ArrowBack: ArrowBackIcon,
  ArrowBackIos: ArrowBackIosIcon,
  ArrowCircleLeft: ArrowCircleLeftIcon,
  ArrowCircleRight: ArrowCircleRightIcon,
  ArrowDropDown: ArrowDropDownIcon,
  ArrowDropDownCircle: ArrowDropDownCircleIcon,
  ArrowForward: ArrowForwardIcon,
  ArrowForwardIos: ArrowForwardIosIcon,
  ArrowLeft: ArrowLeftIcon,
  ArrowOutward: ArrowOutwardIcon,
  ArrowRight: ArrowRightIcon,
  Article: ArticleIcon,
  Assessment: AssessmentIcon,
  Assistant: AssistantIcon,
  AttachFile: AttachFileIcon,
  AutoAwesome: AutoAwesomeIcon,
  Badge: BadgeIcon,
  BarChart: BarChartIcon,
  Bolt: BoltIcon,
  Book: BookIcon,
  Bookmark: BookmarkIcon,
  Brush: BrushIcon,
  BugReport: BugReportIcon,
  Build: BuildIcon,
  Business: BusinessIcon,
  CalendarMonth: CalendarMonthIcon,
  CalendarToday: CalendarTodayIcon,
  CallMade: CallMadeIcon,
  Campaign: CampaignIcon,
  Cancel: CancelIcon,
  Category: CategoryIcon,
  Chat: ChatIcon,
  Check: CheckIcon,
  CheckCircle: CheckCircleIcon,
  Checklist: ChecklistIcon,
  Close: CloseIcon,
  Cloud: CloudIcon,
  CloudDownload: CloudDownloadIcon,
  CloudOff: CloudOffIcon,
  CloudUpload: CloudUploadIcon,
  Code: CodeIcon,
  Contact: ContactPhoneIcon,
  ContactEmail: ContactMailIcon,
  ContactEmergency: ContactEmergencyIcon,
  ContactMail: ContactMailIcon,
  Contacts: ContactsIcon,
  CreditCard: CreditCardIcon,
  Dashboard: DashboardIcon,
  DataObject: DataObjectIcon,
  Database: StorageIcon,
  DateRange: DateRangeIcon,
  Delete: DeleteIcon,
  Description: DescriptionIcon,
  Devices: DevicesIcon,
  Document: DescriptionIcon,
  Domain: DomainIcon,
  Download: DownloadIcon,
  Edit: EditIcon,
  Email: EmailIcon,
  EmojiEvents: EmojiEventsIcon,
  Event: EventIcon,
  Extension: ExtensionIcon,
  Favorite: FavoriteIcon,
  FileCopy: FileCopyIcon,
  FileOpen: FileOpenIcon,
  FileText: ArticleIcon,
  FindInPage: FindInPageIcon,
  Flag: FlagIcon,
  Folder: FolderIcon,
  FolderZip: FolderZipIcon,
  Functions: FunctionsIcon,
  Gavel: GavelIcon,
  GridView: GridViewIcon,
  Group: GroupIcon,
  GroupAdd: GroupAddIcon,
  Help: HelpIcon,
  HexagonOutlined: HexagonOutlinedIcon,
  History: HistoryIcon,
  Home: HomeIcon,
  House: HouseIcon,
  Hub: HubIcon,
  Image: ImageIcon,
  Inbox: InboxIcon,
  Info: InfoIcon,
  InsertDriveFile: InsertDriveFileIcon,
  Insights: InsightsIcon,
  IntegrationInstructions: IntegrationInstructionsIcon,
  Inventory: InventoryIcon,
  Key: KeyIcon,
  KeyboardArrowDown: KeyboardArrowDownIcon,
  KeyboardArrowUp: KeyboardArrowUpIcon,
  Label: LabelIcon,
  Language: LanguageIcon,
  Laptop: LaptopIcon,
  Layers: LayersIcon,
  Lightbulb: LightbulbIcon,
  Link: LinkIcon,
  LinkOff: LinkOffIcon,
  List: ListIcon,
  LocalAtm: LocalAtmIcon,
  LocationOn: LocationOnIcon,
  Lock: LockIcon,
  Mail: MailIcon,
  MailOutline: MailOutlineIcon,
  Map: MapIcon,
  Memory: MemoryIcon,
  Menu: MenuIcon,
  Message: MessageIcon,
  MonetizationOn: MonetizationOnIcon,
  Monitor: MonitorIcon,
  Note: NoteIcon,
  Notifications: NotificationsIcon,
  OpenInNew: OpenInNewIcon,
  Palette: PaletteIcon,
  Pause: PauseIcon,
  Payment: PaymentIcon,
  People: PeopleIcon,
  Percent: PercentIcon,
  Person: PersonIcon,
  Phone: PhoneIcon,
  PhoneInTalk: PhoneInTalkIcon,
  PieChart: PieChartIcon,
  PlayArrow: PlayArrowIcon,
  Psychology: PsychologyIcon,
  Public: PublicIcon,
  Receipt: ReceiptIcon,
  Refresh: RefreshIcon,
  Report: ReportIcon,
  Rectangle: RectangleIcon,
  RocketLaunch: RocketLaunchIcon,
  Route: RouteIcon,
  Rule: RuleIcon,
  Save: SaveIcon,
  Schedule: ScheduleIcon,
  Schema: SchemaIcon,
  Science: ScienceIcon,
  Search: SearchIcon,
  Security: SecurityIcon,
  Send: SendIcon,
  Settings: SettingsIcon,
  Share: ShareIcon,
  ShoppingCart: ShoppingCartIcon,
  SmartToy: SmartToyIcon,
  Smartphone: SmartphoneIcon,
  Sms: SmsIcon,
  Speed: SpeedIcon,
  Star: StarIcon,
  Start: StartIcon,
  Stop: StopIcon,
  Storage: StorageIcon,
  Summarize: SummarizeIcon,
  SupervisorAccount: SupervisorAccountIcon,
  TableChart: TableChartIcon,
  Tag: TagIcon,
  Task: TaskIcon,
  Terminal: TerminalIcon,
  ThumbUp: ThumbUpIcon,
  Timeline: TimelineIcon,
  Timer: TimerIcon,
  TimerOff: TimerOffIcon,
  TrendingUp: TrendingUpIcon,
  Tune: TuneIcon,
  Unarchive: UnarchiveIcon,
  Undo: UndoIcon,
  Upload: UploadIcon,
  UploadFile: UploadFileIcon,
  VideoCall: VideoCallIcon,
  ViewList: ViewListIcon,
  Visibility: VisibilityIcon,
  VoiceChat: VoiceChatIcon,
  Verified: VerifiedIcon,
  Warning: WarningIcon,
  Web: WebIcon,
  Widgets: WidgetsIcon,
  Work: WorkIcon,
  X: XIcon,
};

// Module-level registry of brand icon components
const BRAND_ICON_COMPONENTS: Record<string, IconType> = {
  Slack: TbBrandSlack,
  MicrosoftTeams: TbBrandTeams,
};

type IconComponentProps = {
  iconName?: string;
  size?: "small" | "medium" | "large" | "inherit";
  fontSize?: number | string;
  color?: string;
};

const getIcon = (
  iconName: string,
  fontSize?: "small" | "medium" | "large" | "inherit",
  customFontSize?: number | string,
  color?: string
): React.ReactElement => {
  if (iconName in BRAND_ICON_COMPONENTS) {
    const BrandIcon = BRAND_ICON_COMPONENTS[iconName];
    const brandSize = customFontSize || (fontSize === "large" ? 36 : fontSize === "small" ? 20 : 24);
    return BrandIcon({ size: brandSize, color }) as React.ReactElement;
  }

  const style = customFontSize ? { fontSize: customFontSize } : undefined;
  // MUI palette names (e.g. "error", "primary") must go via the `color` prop so the theme
  // resolves them correctly. Arbitrary CSS values go via sx instead.
  const colorProps = color ? (isMuiPaletteColor(color) ? { color: color as any } : { sx: { color } }) : {};
  const props = { fontSize, style, ...colorProps };
  const MuiIcon = MUI_ICON_COMPONENTS[iconName] ?? MenuIcon;
  return <MuiIcon {...props} />;
};

const IconComponent: React.FC<IconComponentProps> = ({ iconName, size, fontSize, color }) => {
  if (!iconName) {
    return getIcon("Menu", size, fontSize, color);
  }

  return getIcon(iconName, size, fontSize, color);
};

export default IconComponent;
